import { bootstrapAnalytics } from './analytics.utils';

/**
 * Side-effect-only module, imported as the very first import of `index.tsx`.
 *
 * Import declarations are hoisted, so calling `bootstrapAnalytics()` from a
 * statement in `index.tsx` would still run *after* every imported module was
 * evaluated — including `i18n`, which throws at module scope when the host
 * locale is missing and would take the whole bundle down with it. Being the
 * first import is the only way to guarantee analytics starts first.
 */
bootstrapAnalytics();
